import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doPost, doGet } from "../../../../../utils/request";
import PopupModal from "../../../../../Components/PopupModal";
import DataTable from "../../../../../Components/DataTable";
import * as dropDownActions from "../../../../../actionCreators/DropDown";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Polygon } from "@react-google-maps/api";
import { Form, Row, Col, Select, Button, Typography, Input } from "antd";
import * as propertyActions from "../../../../../actionCreators/Property";
import "../style/propertyListing.css";
const { Option } = Select;
const { TextArea } = Input;

const MLProperties = ({
  Mlproperties,
  getMlProperties,
  getPropertyData,
  getInspectors,
  inspectors,
}) => {
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const [inspector, setInspector] = React.useState(null);
  const [priority, setPriority] = React.useState(null);
  const [property_id, setProperty_id] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [properties, setProperties] = React.useState("");
  const [propertyInspectors, setInspectors] = React.useState("");
  const [assignProperty, setAssignProperty] = React.useState(false);
  const [current, setCurrent] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [showRow, setShowRow] = React.useState(false);
  const [paths, setPaths] = React.useState([]);
  const [rejectionNote, setRejectionNote] = React.useState("");
  const [removalReason, setRemovalReason] = React.useState(null);
  const [showWarning, setShowWarning] = React.useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = React.useState(false);

  const [form] = Form.useForm();
  const containerStyle = {
    width: "100%",
    height: "400px",
  };
  const [center, setCenter] = React.useState({});
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);

  const options = {
    fillColor: "rgba(33, 150, 243, 0.4)",
    fillOpacity: 0.4,
    strokeColor: "rgba(33, 150, 243, 1)",
    strokeOpacity: 1,
    strokeWeight: 1,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };
  React.useEffect(() => {
    getMlProperties({ page: 0, pageSize: 10 });
  }, []);
  React.useEffect(() => {
    if (Mlproperties.data) {
      setProperties(Mlproperties.data);
      setPagination(Mlproperties.pagination);
      setLoading(Mlproperties.loading);
    }
  }, [Mlproperties]);
  const handleTablePageChange = (tableChangeData) => {
    const { current, pageSize } = tableChangeData;
    setCurrent(tableChangeData.current);
    setPageSize(tableChangeData.pageSize);
    getMlProperties({ page: current - 1, pageSize });
  };
  const handleFinish = async (values) => {
    setLoading(true);
    if (inspector) {
      values = { ...values, inspector: inspector };
    }
    if (priority) {
      values = { ...values, priority: priority };
    }
    if (property_id) {
      values = { ...values, property_id: property_id };
    }
    if (inspector && priority) {
      const assignInspector = await doPost(
        "/properties/detected/assign",
        values
      );
      setAssignProperty(false);
      await getMlProperties({ page: current - 1, pageSize });
    }
  };
  const handleRejectionNote = (e) => {
    setRejectionNote(e.target.value);
  };
  const handleCancleButton = () => {
    setShowDeleteModal(false);
    setRejectionNote("");
  };
  const handleDeleteLink = async (data) => {
    setShowDeleteModal(true);
    setProperty_id(data?.id);
  };
  const handleDeleteButton = async () => {
    setLoading(true);
    let deleteProperty = await doPost("/properties/detected/remove", {
      removal_note: rejectionNote,
      property_id: property_id,
    });
    setShowDeleteModal(false);
    setShowDeleteWarning(false);
    setRejectionNote("");
    await getMlProperties({ page: current - 1, pageSize });
  };
  const tableColumns = [
    {
      title: "UID",
      dataIndex: "id",
      align: "center",
      render: (id) => (id ? id : "---"),
    },
    {
      title: "Location",
      dataIndex: "latitude",
      width: "20%",
      align: "center",
      render: (latitude, row) =>
        latitude ? `${latitude}, ${row?.longitude}` : "---",
    },
    // {
    //   title: "Circle",
    //   align: "center",
    //   dataIndex: "circle",
    //   render: (circle) => (circle ? circle?.name : "---"),
    // },
    {
      title: "Highway",
      align: "center",
      dataIndex: "highway",
      render: (highway) => (highway ? highway?.name : "---"),
    },
    {
      title: "Assigned to",
      align: "center",
      dataIndex: "inspector",
      render: (inspector) => (inspector ? inspector : "---"),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      align: "center",
      render: (priority) => (priority ? priority : "---"),
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      render: (status) => (status ? status : "---"),
    },
    {
      title: "Property Size",
      align: "center",
      dataIndex: "area",
      render: (area) => {
        let a = area * 91.44;
        if (a < 90) {
          return <span>SMALL</span>;
        } else if (a > 90 && a < 320) {
          return <span>MEDIUM</span>;
        } else {
          return <span>LARGE</span>;
        }
      },
    },
    {
      title: "Actions",
      align: "center",
      dataIndex: "status",
      render: (status, row) => {
        if (status === "Newly Detected" || status === "Removed by TI") {
          return (
            <>
              <span
                style={{
                  color: "#2196F3",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  onAssginProperty(row);
                }}
              >
                Assign Property
              </span>
              <span
                style={{ color: "gray", marginLeft: "6px", marginRight: "6px" }}
              >
                |
              </span>
              <span
                style={{
                  color: "red",
                  textDecoration: "underline",
                }}
                onClick={() => handleDeleteLink(row)}
              >
                Delete
              </span>
            </>
          );
        } else {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClick(row);
              }}
            >
              View
            </span>
          );
        }
      },
    },
  ];
  const onAssginProperty = async (data) => {
    setAssignProperty(true);
    let Highway_inspectors = await doGet(
      "/dropdowns/TiFromHighway?id=" + data?.highway?.id
    );
    setInspectors(Highway_inspectors.data.data);
    setProperty_id(data.id);
  };
  const onTableRowClick = (data) => {
    var temp = [];
    setRemovalReason(data?.removal_note);
    if (data.polygon_lat_long) {
      data.polygon_lat_long.map((value) => {
        let obj = {
          lat: value[0],
          lng: value[1],
        };
        temp.push(obj);
      });
      setPaths([...temp]);
    } else {
      setPaths([]);
    }
    let cnt = {
      lat: parseFloat(data.latitude),
      lng: parseFloat(data.longitude),
    };
    setCenter({ ...cnt });
    setShowRow(true);
  };
  return (
    <div>
      <DataTable
        rowClassName="table-row-cursor-pointer"
        columns={tableColumns}
        pagination={pagination}
        loading={loading}
        data={properties}
        handleTableValuesChange={handleTablePageChange}
        onRowClick={onTableRowClick}
        selction={false}
      />
      {assignProperty ? (
        <PopupModal
          title={"Assign to"}
          centered
          visible={assignProperty}
          onCancel={() => setAssignProperty(false)}
          footer={[
            <Button
              key="cancel"
              type="link"
              onClick={() => setAssignProperty(false)}
            >
              CANCEL
            </Button>,
            <Button
              key="submit"
              type="link"
              loading={loading}
              onClick={() => {
                handleFinish();
              }}
              disabled={inspector && priority ? false : true}
            >
              CONFIRM
            </Button>,
          ]}
        >
          <Row>
            <Col span={24}>
              <Form onFinish={handleFinish} form={form}>
                <Row>
                  <Col span={24}>
                    <Form.Item>
                      <Select
                        placeholder="Inspector"
                        value={inspector}
                        disabled={propertyInspectors ? false : true}
                        size="large"
                        className="select-field"
                        allowClear
                        onChange={(event) => setInspector(event)}
                        loading={propertyInspectors ? false : true}
                      >
                        {propertyInspectors &&
                          propertyInspectors?.map((PropertyInspectors) => {
                            return (
                              <Option
                                value={PropertyInspectors?.id}
                                key={PropertyInspectors?.id}
                              >
                                {PropertyInspectors?.full_name}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="priority">
                      <Select
                        placeholder="Priority"
                        value={priority}
                        size="large"
                        className="select-field"
                        onChange={(event) => setPriority(event)}
                        allowClear
                      >
                        <Option key={1} value={"High"}>
                          High
                        </Option>
                        <Option key={2} value={"Medium"}>
                          Medium
                        </Option>
                        <Option key={3} value={"Low"}>
                          Low
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </PopupModal>
      ) : (
        ""
      )}
      {showRow ? (
        <PopupModal
          title={"Detected Property"}
          centered
          visible={showRow}
          onCancel={() => setShowRow(false)}
          footer={[]}
        >
          {removalReason && (
            <div className="removal-reason-container">
              <Typography className="removal-reason-header">
                Removal Note :
              </Typography>
              <div className="removal-reason">{removalReason}</div>
            </div>
          )}
          <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={17}
            >
              {paths && paths.length > 0 ? (
                <Polygon paths={paths} options={options} />
              ) : (
                <Marker key={1} position={center} />
              )}
            </GoogleMap>
          </LoadScript>
        </PopupModal>
      ) : (
        <></>
      )}
      <PopupModal
        title={"Reason for Deletion"}
        centered
        visible={showDeleteModal}
        onCancel={handleCancleButton}
        footer={[
          <Button key="cancel" type="link" onClick={handleCancleButton}>
            CANCEL
          </Button>,
          <Button
            key="submit"
            type="link"
            onClick={() => {
              if (rejectionNote === "") {
                setShowWarning(true);
              } else {
                setShowDeleteWarning(true);
              }
            }}
            style={{ color: "red" }}
          >
            DELETE
          </Button>,
        ]}
      >
        <TextArea
          rows={4}
          name="rejection-note"
          placeholder="Note"
          onChange={handleRejectionNote}
          value={rejectionNote}
        />
      </PopupModal>
      <PopupModal
        title={"Warning"}
        centered
        visible={showWarning}
        onCancel={() => setShowWarning(false)}
        footer={[
          <Button
            key="submit"
            type="link"
            onClick={() => {
              setShowWarning(false);
            }}
          >
            OK
          </Button>,
        ]}
      >
        Enter a valid Deletion reason.
      </PopupModal>
      <PopupModal
        title={"Delete Property"}
        centered
        visible={showDeleteWarning}
        onCancel={() => setShowDeleteWarning(false)}
        footer={[
          <Button
            key="submit"
            type="link"
            onClick={() => {
              setShowDeleteWarning(false);
            }}
          >
            No
          </Button>,
          <Button
            key="submit"
            type="link"
            loading={loading}
            onClick={() => {
              handleDeleteButton();
            }}
          >
            Yes
          </Button>,
        ]}
      >
        Are you sure you want to detele this property?
      </PopupModal>
    </div>
  );
};

const mapStateToProps = ({
  property: { Mlproperties },
  dropDown: { inspectors },
}) => ({ Mlproperties, inspectors });

const mapDispatchToProps = (dispatch) => ({
  getMlProperties: bindActionCreators(
    propertyActions.getMlProperties,
    dispatch
  ),
  getInspectors: bindActionCreators(dropDownActions.getInspectors, dispatch),
});

MLProperties.propTypes = {
  Mlproperties: PropTypes.object.isRequired,
  getMlProperties: PropTypes.func.isRequired,
  getInspectors: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MLProperties);
// export default MLProperties;
